<template>
  <div class="absolute top-20 right-20 z-20">
    <div class="bg-white rounded-md shadow overflow-hidden w-full mb-6 px-4">
      <form id="noteForm" name="noteForm" @submit.prevent="addNote">
        <div class="grid col-span-6 lg:grid-cols-6 text-indigo-400 w-full">
          <div class="px-2 w-full gap-2 col-span-3">
            <span class="btn-indigo w-32 font-normal mr-2 mt-4 inline-block" @keydown.enter.prevent @click="updateMessage('Left Voicemail')">Left Voicemail</span>
            <span class="btn-indigo w-32 font-normal mr-2 mt-4 inline-block" @keydown.enter.prevent @click="updateMessage('No Answer')">No Answer</span>
            <span class="btn-indigo w-32 font-normal mr-2 mt-4 inline-block" @keydown.enter.prevent @click="updateMessage('Bad Phone')">Bad Phone</span>
          </div>
          <div class="px-2 mt-4 w-full col-span-2">
            <text-input v-model="noteForm.note" class="relative pr-6 pb-4 w-full" placeholder="call note..." />
          </div>
          <div class="px-2 mt-4 w-full gap-2 col-span-1">
            <loading-button :loading="noteForm.processing" class="btn-indigo ml-auto" type="submit">Save Note</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
  import { router } from '@inertiajs/vue3'

export default {
  name: 'CallingNote',
  components: {
    TextInput,
    LoadingButton,
  },
  props: {
    leadId: String,
    contactId: String,
    auth: Object,
  },
  data() {
    return {
      noteForm: router.form({
        note: null,
        user_id: this.auth.user.id,
        type: 'note',
        lead_id: this.leadId,
        contact_id: this.contactId,
      }),
    }
  },
  watch:{
    leadId: function(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.noteForm.lead_id = newVal
    },
    contactId: function(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.noteForm.contact_id = newVal
    },
  },
  methods: {
    updateMessage(value){
      this.noteForm.note = value
      this.addNote()
    },
    addNote() {
      //console.log(this.noteForm.message)
      this.noteForm.post('/notes', {
        onSuccess: () => {
          this.noteForm.reset('note'),
          console.log('Note Saved.')
        },
        preserveScroll: true,
      })
    },
  },
}
</script>
